import { ETime } from '@common/enums/time.enum';

export const defaultTimerLabels = {
    [ETime.days]: 'timer_default_label_days',
    [ETime.hours]: 'timer_default_label_hours',
    [ETime.minutes]: 'timer_default_label_minutes',
    [ETime.seconds]: 'timer_default_label_seconds',
};
